import { MasterDialog } from "#common/Dialog/Dialog"
import CircularSkeleton from "#common/skeleton/CircularSkeleton"
import ErrorResponse from "#core/pages/ErrorResponse"
import { useApi } from "#hooks/useApi"
import { Viewer, Worker } from "@react-pdf-viewer/core"
import { useCallback, useMemo } from "react"

export default function ViewPdf({ data, loading, error }) {
	if (loading) return <CircularSkeleton />
	if (error) return <ErrorResponse api={error} />

	return (
		<Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
			<Viewer fileUrl={data} />
		</Worker>
	)
}

export const ViewPdfDialog = ({
	title,
	open,
	setOpen,
	apiGet,
	apiParams,
	moreParams,
	fileName,
}) => {
	const params = useMemo(
		() => ({ params: { get_url: true, ...apiParams }, ...moreParams }),
		[apiParams, moreParams]
	)
	const { data, loading, error } = useApi(apiGet, { autoFetch: open, params })

	const handleDownload = useCallback(() => {
		if (fileName) downloadFileName(data, fileName)
		downloadFile(data)
	}, [data, fileName])

	const buttons = useMemo(
		() => [
			{ label: "Cerrar", onClick: () => setOpen(false) },
			{ label: "Descargar", onClick: handleDownload },
		],
		[handleDownload, setOpen]
	)

	return (
		<MasterDialog {...{ title, open, setOpen, maxWidth: "md", buttons }}>
			<ViewPdf {...{ data, loading, error }} />
		</MasterDialog>
	)
}

const downloadFile = (urlFile) => {
	const link = document.createElement("a")
	link.href = urlFile // La URL del archivo
	document.body.appendChild(link)
	link.click()
	document.body.removeChild(link)
}

const downloadFileName = async (url, name = null) => {
	const response = await fetch(url)
	const blob = await response.blob()

	const blobUrl = window.URL.createObjectURL(blob)
	const a = document.createElement("a")
	a.href = blobUrl
	a.download = name
	document.body.appendChild(a)
	a.click()
	document.body.removeChild(a)
	window.URL.revokeObjectURL(blobUrl)
}
